import { Tr, Td } from '@chakra-ui/react';
import React from 'react';
import { getCreatorName } from '../../../services/text/getCreatorName';
import { localise } from '../../../services/lang/lang';
import { optionalValue } from '../../../services/text/optionalValue';
import ConditionalTooltip from '../Tooltip/ConditionalTooltip';
export const getInspectionListingRowData = (inspection, scope) => [
    {
        key: 'address',
        content: inspection._formatted.address ?? localise('DRAFT'),
    },
    {
        key: 'uprn',
        content: inspection._formatted.uprn,
    },
    {
        key: 'reference',
        content: inspection.reference,
    },
    {
        key: 'inspection_date',
        content: inspection._formatted.inspection_date,
    },
    {
        key: 'inspector',
        content: getCreatorName(inspection),
        condition: scope === 'team-inspections',
    },
    {
        key: 'hazards',
        content: inspection._formatted.hazard_count,
    },
    {
        key: 'cat1',
        content: inspection._formatted.hazard_cat1_count,
    },
    {
        key: 'cat2',
        content: inspection._formatted.hazard_cat2_count,
    },
    {
        key: 'scored',
        content: inspection.score_status,
    },
    {
        key: 'actions',
        content: () => {
            const actions = inspection._formatted.actions
                ? Object.keys(inspection._formatted.actions).filter(Boolean)
                : [];
            const hasMultipleActions = actions.length > 1;
            const actionText = hasMultipleActions
                ? localise('MULTIPLE')
                : actions?.[0];
            return (React.createElement(ConditionalTooltip, { label: actions.join(', '), condition: hasMultipleActions }, optionalValue(actionText)));
        },
    },
    {
        key: 'last_updated',
        content: inspection._formatted.last_updated,
    },
];
const shouldDisplayColumn = (col, selectedColumns) => {
    if ('condition' in col && col.condition === false) {
        return false;
    }
    if (!selectedColumns)
        return true;
    return selectedColumns.includes(col.key);
};
const InspectionsTableRow = ({ inspection, scope, selectedColumns, onRowClicked, children, childCellWidth, }) => {
    const columns = getInspectionListingRowData(inspection, scope);
    return (React.createElement(Tr, { sx: {
            td: {
                cursor: 'pointer',
            },
        }, "data-testid": "inspections_table_row", onClick: () => onRowClicked?.(inspection) },
        React.createElement(Td, { w: childCellWidth }, children),
        columns
            .filter((col) => shouldDisplayColumn(col, selectedColumns))
            .map((col) => (React.createElement(Td, { key: col.key, "data-testid": `inspections_table_row__${col.key}` }, typeof col.content === 'function' ? col.content() : col.content)))));
};
export default InspectionsTableRow;
